import styled from 'styled-components'

export const DesktopViewWrapper = styled.div`
  @media (max-width: ${({ $breakpoint }) => $breakpoint - 1}px) {
    display: none;
  }
`

export const DesktopViewMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 6.5rem 0 7.75rem;
  text-align: center;

  p {
    font-size: 1.125rem;
    margin-top: 1.0625rem;
  }

  @media (min-width: ${({ $breakpoint }) => $breakpoint}px) {
    display: none;
  }
`

export const DesktopViewImg = styled.img`
  object-fit: cover;
  width: 2.8rem;
  height: 100%;
`
